(function () {
  kPatientAlertService.$inject = ['$http', '$q'];
  function kPatientAlertService($http, $q) {
    const billingProfilesURL = '/billing-profiles-ui/api/PatientAlert/';

    function getPatientAlert(patientGuid) {
      return $http.get(billingProfilesURL + patientGuid + '/alert')
        .then((response) => {
          if (response.status === 204) {
            //  indicates the alert  DNE
            return null;
          }
            return response.data;
        });
      //  failure function is intentionally not provided, should be handled by the consumer
    }

    function createPatientAlert(patientGuid, alert) {
      return $http.post(billingProfilesURL + patientGuid + '/alert', alert)
        .then((response) => {
          return response.data;
        }, (err) => {
          return $q.reject(err);
        });
    }

    function updatePatientAlert(patientGuid, alertId, alert) {
      return $http.put(billingProfilesURL + patientGuid + '/alert/' + alertId, alert)
        .then((response) => {
          return response.data;
        }, (err) => {
          return $q.reject(err);
        });
    }

    function deletePatientAlert(patientGuid, alertId) {
      return $http.delete(billingProfilesURL + patientGuid + '/alert/' + alertId)
        .then((response) => {
          return response.data;
        }, (err) => {
          return $q.reject(err);
        });
    }

    return {
      getPatientAlert,
      createPatientAlert,
      updatePatientAlert,
      deletePatientAlert
    };
  }

  angular.module('kareo.ui.shared.modules.api.k-patient-alert-service', []).factory('kPatientAlertService', kPatientAlertService);
})();
